import _styled, { default as _styled2 } from "styled-components";
export type ChipEvolutionGraphBulletPointViewProps = {
  text?: string | null;
};
export function ChipEvolutionGraphBulletPointView({
  text
}: ChipEvolutionGraphBulletPointViewProps) {
  return <_StyledDiv>
      <_StyledSpan />
      <p>{text}</p>
    </_StyledDiv>;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-1qpbfdc-0"
})({
  "display": "flex",
  "alignItems": "center",
  "columnGap": "1.6rem",
  "padding": "1.6rem"
});
var _StyledSpan = /*#__PURE__*/_styled2("span").withConfig({
  displayName: "chip-evolution-graph-bullet-point___StyledSpan",
  componentId: "sc-1cu8nbv-0"
})({
  "height": "0.8rem",
  "width": "0.8rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))"
});